import * as yup from "yup";

const passwordRules =
	/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

const passwordRequirementsMessage = (
    <>
		<p>Password requirements:</p>
		<ul>
			<li>Minimum 5 characters</li>
			<li>At least 1 uppercase letter</li>
			<li>At least 1 lowercase letter</li>
			<li>At least 1 number</li>
            </ul>
	</>
);
const Schema = yup.object().shape({
	username: yup
		.string()
		.min(3, "Username must be at least 3 characters long")
		.required("Required"),

	email: yup
		.string()
		.email("Please enter a valid email")
		.required("Required"),

	password: yup
		.string()
		.min(5)
		.test(
			"password-rules",
			passwordRequirementsMessage,
			function (value) {
				return passwordRules.test(value);
			}
		)
		.required("Required"),

	confirmPassword: yup
		.string()
		.oneOf(
			[yup.ref("password"), null],
			"Passwords must match"
		)
		.required("Required"),

	role: yup
		.string()
		.oneOf(
			["LocalGuide", "Tourist"],
			"Please select a role"
		)
		.required("Required"),

	acceptedTos: yup
		.boolean()
		.oneOf([true], "Please accept the terms of service"),
});

export default Schema;